// extracted by mini-css-extract-plugin
module.exports = {"container":"remove_container__259mW","name":"remove_name__1DD3h","text":"remove_text__1n8Bu","btn":"remove_btn__1ItCm"};